import { render } from "./themes-filter.vue?vue&type=template&id=edbb4bc8"
import script from "./themes-filter.vue?vue&type=script&lang=js"
export * from "./themes-filter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\sander\\IdeaProjects\\matchmaking\\fbm-matchmaking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__